import { type ProjectName, monitoringConfig } from '@dinewise/config';
import {
  browserProfilingIntegration,
  init,
  reactRouterTracingIntegration,
} from '@sentry/react-router';
import { redactBearerTokenBreadcrumb, redactBearerTokenEvent } from '../bearer-token-routes.ts';

const { projects } = monitoringConfig;

declare const __SENTRY_RELEASE__: string;
declare const __IS_SENTRY_ENABLED__: boolean;
declare const __SENTRY_ENVIRONMENT__: string;

export const initialize = (serviceName: ProjectName) => {
  init({
    enabled: __IS_SENTRY_ENABLED__,
    dsn: projects[serviceName].sentryDsn,
    sendDefaultPii: false,
    release: __SENTRY_RELEASE__,
    environment: __SENTRY_ENVIRONMENT__,
    tracesSampleRate: 1,
    enableLogs: true,
    normalizeDepth: 8,
    integrations: [
      reactRouterTracingIntegration({ useInstrumentationAPI: true }),
      browserProfilingIntegration(),
    ],
    beforeBreadcrumb: redactBearerTokenBreadcrumb,
    beforeSend: redactBearerTokenEvent,
    beforeSendTransaction: redactBearerTokenEvent,
    tracePropagationTargets: ['localhost', /^\//, /dinewise\.com\//, /ande\.ai\//],
  });
};
